<script>
import { useAlert } from 'dashboard/composables';

export default {
  components: {},
  props: {
    message: {
      type: Object,
      default: () => {},
      required: true,
    },
    inboxId: {
      type: Number,
      required: true,
    },
    messageOrder: {
      type: Number,
      required: true,
    },
    timeOptions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      teimosinhaEnabled: false,
      privateMessage: false,
      messageContent: '',
      messageTime: 0,
      isLoading: false,
    };
  },
  computed: {
    firstMessagePossibleTimes() {
      return [...this.timeOptions];
    },
    pageTitle() {
      return (
        this.$t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.HEADER') +
        ' ' +
        this.messageOrder
      );
    },
  },
  mounted() {
    this.setInitialValues();
  },
  methods: {
    setInitialValues() {
      this.messageContent = this.message.content;
      this.messageTime = this.message.time_to_send_seconds;
      this.privateMessage = this.message.private_message;
    },
    async editTeimosinhaMessage() {
      const payload = {
        inboxId: this.inboxId,
        messageId: this.message.id,
        teimosinhaSettings: {
          content: this.messageContent,
          time_to_send_seconds: this.messageTime,
          private_message: this.privateMessage,
        },
      };
      try {
        this.isLoading = true;
        await this.$store.dispatch(
          'inboxes/updateTeimosinhaMessageSettings',
          payload
        );
        this.isLoading = false;
        this.onClose();
        useAlert(
          this.$t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.API.SUCCESS_MESSAGE')
        );
      } catch (error) {
        useAlert(
          this.$t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.API.ERROR_MESSAGE')
        );
        this.isLoading = false;
      }
    },
    onClose() {
      this.$emit('close');
    },
  },
};
</script>

<template>
  <div class="h-auto overflow-auto flex flex-col">
    <woot-modal-header :header-title="pageTitle" />
    <form class="mx-0 flex flex-wrap" @submit.prevent="editTeimosinhaMessage">
      <!-- TIME WITHOUT RESPONSE -->
      <div>
        <label>
          {{
            $t(
              'INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.TIME_WITHOUT_RESPONSE.HEADER'
            )
          }}
        </label>
        <span class="text-xs">
          {{
            $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.TIME_WITHOUT_RESPONSE.INFO')
          }}
        </span>
        <select v-model="messageTime">
          <option
            v-for="time in timeOptions"
            :key="time.key"
            :value="time.key"
            :disabled="time.disabled"
          >
            {{ time.name }}
          </option>
        </select>
      </div>
      <!-- PRIVATE MESSAGE -->
      <div>
        <label>
          {{ $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.PRIVATE_MESSAGE.HEADER') }}
        </label>
        <span class="text-xs">
          {{ $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.PRIVATE_MESSAGE.INFO') }}
        </span>
        <select v-model="privateMessage">
          <option key="true" :value="true">
            {{ $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.PRIVATE_MESSAGE.YES') }}
          </option>
          <option key="false" :value="false">
            {{ $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.PRIVATE_MESSAGE.NO') }}
          </option>
        </select>
      </div>
      <!-- MESSAGE CONTENT -->
      <woot-input
        v-model.trim="messageContent"
        v-tooltip.bottom="messageContent"
        class="w-full"
        :label="$t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.MESSAGE_CONTENT.HEADER')"
        :placeholder="
          $t('INBOX_MGMT.TEIMOSINHA.EDIT_MESSAGE.MESSAGE_CONTENT.PLACE_HOLDER')
        "
      />

      <!-- :is-disabled="v$.title.$invalid || uiFlags.isUpdating"
          :is-loading="uiFlags.isUpdating" -->
      <div class="flex justify-end items-center py-2 px-0 gap-2 w-full">
        <woot-button :is-loading="isLoading">
          {{ $t('LABEL_MGMT.FORM.EDIT') }}
        </woot-button>
        <woot-button
          :is-loading="isLoading"
          class="button clear"
          @click.prevent="onClose"
        >
          {{ $t('LABEL_MGMT.FORM.CANCEL') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>
